import './style.less';

export default function($log, $state) {
  'ngInject';

  const vm = this;

  $log.debug('Activating No Content Ctrl');

  vm.next = () => {
    if (vm.state) {
      return $state.go(vm.state, vm.params);
    }

    if (vm.callback) {
      vm.callback()();
      vm.disable = true;
    }

    $log.error('No Button Action');
  };
}



// WEBPACK FOOTER //
// ./src/app/components/noContent/controller.js